<template>
    <div class="storeInfo">
        <div class="box">
            <div class="house"><i class="ico ico-icon_14"></i></div>
            <h3>{{ storeInfo.store_name }}</h3>
            <p>距离您{{ storeInfo.distance | distance2 }} | {{ storeInfo.store_address }}</p>
            <div class="phone" @click="onCallPhone"><i class="ico ico-icon_76"></i></div>
            <div class="address" @click="onGoStore"><i class="ico ico-icon_77"></i></div>
        </div>

        <div class="btnBox">
            <button class="btn" @click="onShowAppGuideDialog">进入门店商城</button>
        </div>
        <appGuideDialog ref="appGuideDialog" :phpSstoreId="storeInfo.store_id" :type="jumpType"/>
    </div>
</template>

<script>
import appGuideDialog from '@/components/appGuideDialog/appGuideDialog.vue'
export default {
    name: 'storeInfo',
    props: {
        storeInfo: {
            type: Object,
            default () {
                return {}
            }
        },
        jumpType: {
            type: String,
            default () {
                return 'mall' // 跳转小程序页面
            }
        }
    },
    components: {
        appGuideDialog
    },
    data () {
        return {

        }
    },
    methods: {
        /**
         * 进入门店商城，提示app下载弹窗
         */
        onShowAppGuideDialog () {
            this.$refs.appGuideDialog.open()
        },
        /**
         * 打电话给门店
         */
        onCallPhone () {
            const { mobile } = this.storeInfo
            window.location.href = 'tel://' + mobile
        },
        /**
         * 前往门店
         */
        onGoStore () {
            const { lng, lat, store_name, store_address } = this.storeInfo
            window.location.href = `https://api.map.baidu.com/marker?location=${lat},${lng}&title=${store_name}&content=${store_address}&output=html&src=webapp.baidu.openAPIdemo`
        },
    }
}
</script>

<style lang="stylus" scoped>
@import '../../../assets/stylus/variables'
.storeInfo
    position relative
    padding-bottom 20px
    background #fff
    .box
        padding 26px 84px 30px 68px
        h3
            font-size 30px
            line-height 38px
            color #333333
            word-break break-all
        p
            color #999999
            font-size 23px
            line-height 30px
            margin-top 30px
        .house
            position absolute
            top 30px
            left 20px
        .phone
            position absolute
            right 42px
            top 25px
        .address
            position absolute
            right 42px
            top 85px
    .btnBox
        text-align center
        .btn
            font-size 28px
            color #fc2d2d
            box-sizing border-box
            display inline-block
            width 330px
            height 60px
            line-height 58px
            border 1px solid #fc2d2d
            border-radius 30px
            background #ffdede
</style>
